module.exports = __webpack_public_path__ + "static/favicon.f505cecb.ico";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/public/uploads/icons/favicon.ico
// module id = 197
// module chunks = 0 1 2